export default __webpack_public_path__ + "images/0x201eba5cc46d216ce6dc03f6a759e8e766e956ae.png";